import React, { Component, Fragment } from 'react'

import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import ComputerNetwork from '../components/others/ComputerNetwork.jsx'
import NewsletterSubscribe from '../components/others/NewsletterSubscribe';


class ComputerNetworkPage extends Component {
     render() {
          return (
               <Fragment> 
               <div className="Desktop">
                <NavMenuDesktop /> 
               </div>

               <div className="Mobile">
               <NavMenuMobile />  
               </div>                       

               <ComputerNetwork /> 
               <NewsletterSubscribe/>
               <div className="Desktop">
               <FooterDesktop/>
               </div>

               <div className="Mobile">
               <FooterMobile/>
               </div>
               
          </Fragment>
          )
     }
}

export default ComputerNetworkPage